<header id="header">
    <a [routerLink]="['/home']">
        <img src="assets/img/logos/Logos_GlobalIPCert_V3_2.png" alt="Logo" class="logo" id="imgHeaderInf">
    </a>
     <span (click)="showLanguages = !showLanguages">{{selectedLanguage | translate}}<span
            *ngIf="!showLanguages">▾</span><span *ngIf="showLanguages">▴</span></span>
    <div *ngIf="showLanguages" class="dropdown" @openCloseAnimation>
        <ul>
            <li (click)="changeLanguage(1)">
                <div class="language">
                    <img src="assets/img/idiomas/flag-espana.png"
                        alt="{{'header-superior.idiomas.altEsp' | translate}}">
                    <span>{{'header-superior.idiomas.esp' | translate}}</span>
                </div>
            </li>
            <li (click)="changeLanguage(2)">
                <div class="language">
                    <img src="assets/img/idiomas/flag-gb.png" alt="{{'header-superior.idiomas.altUK' | translate}}">
                    <span>{{'header-superior.idiomas.ingUK' | translate}}</span>
                </div>
            </li>
            <li (click)="changeLanguage(3)">
                <div class="language">
                    <img src="assets/img/idiomas/flag-usa.png" alt="{{'header-superior.idiomas.altUSA' | translate}}">
                    <span>{{'header-superior.idiomas.ingUSA' | translate}}</span>
                </div>
            </li>
        </ul>
    </div>
    <!-- <nav>
        <ul [ngClass]="{'active': active}" class="site-nav">
            <li><a [routerLink]="'/sistema-globalipcert'" title="" routerLinkActive="active">{{ 'header-inferior.sistema-globalIPCert' |
                    translate}}</a></li>
            <li><a [routerLink]="'/certificado-ip'" title="" routerLinkActive="active">{{ 'header-inferior.certificado-IP' |
                    translate}}</a></li>
            <li><a [routerLink]="'/support'" title="" routerLinkActive="active">{{ 'header-inferior.support' |
                    translate}}</a></li>
        </ul>
        <label for="nav-toggle" class="icon-burger" [ngClass]="{'active': active}" (click)="activeMenu()">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </label>
    </nav> -->

</header>